import React from 'react';
import { useAuth, useUsers } from 'api';
import { Redirect } from 'react-router-dom';
import { Title, Card, Text, Button } from 'ui';
import "./index.css";

export default function Users(props) {
  const auth = useAuth();
  const users = useUsers();
  
  if(!auth || !users) {
    return null;
  }
  
  if(auth.user.role !== "ADMIN") {
    return <Redirect to="/"/>;
  }
  
  return (
    <div className="users">
      <Title block className="users-title">Users</Title>
      {users.map(item => 
        <Card key={item.id} className="users-user-card">
          <div className="users-user-info">
            <Text className="users-user-name">{item.displayName || "Unnamed User"}</Text>
            <Text small block className="users-user-email">{item.email || ""}</Text>
            <Text small block className="users-user-plan">{item.plan ? item.plan.name : ""}</Text>
          </div>
          <div className="users-user-actions">
            <Button to={item.id}>View</Button>
          </div>
        </Card>
      )}
      
    </div>
  );
}